module.exports = __webpack_public_path__ + "static/img/1959_04_15_VillageVoice_AVConcert_Review.4569207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_04_15_VillageVoice_AVConcert_Review.jpg
// module id = Mufq
// module chunks = 0